var map = {
	"./0.png": 2061,
	"./1.png": 1801,
	"./2.png": 37,
	"./3.png": 1122,
	"./4.png": 6569,
	"./5.png": 726,
	"./6.png": 6178,
	"./7.png": 2658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9916;